import { convertToInty04h231mmjoh as convertToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readByteArray1fhzfwi2j014k as readByteArray } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readBytes(_this__u8e3s4, count) {
  count = count === VOID ? convertToInt(_this__u8e3s4.get_size_woubt6_k$()) : count;
  return readByteArray(_this__u8e3s4, count);
}
//region block: exports
export {
  readBytes as readBytesj5m5qe40si0k,
};
//endregion

//# sourceMappingURL=Buffers.mjs.map
